import React from 'react'

import PropTypes from 'prop-types'

import './rea-processo-extra-judicial.css'

const ReaProcessoExtraJudicial = (props) => {
  return (
    <div className="rea-processo-extra-judicial-container1">
      <div className="rea-processo-extra-judicial-container2">
        <span className="rea-processo-extra-judicial-text">{props.titulo}</span>
      </div>
      {props.children}
    </div>
  )
}

ReaProcessoExtraJudicial.defaultProps = {
  titulo: 'Titulo',
  rootClassName: '',
}

ReaProcessoExtraJudicial.propTypes = {
  titulo: PropTypes.string,
  rootClassName: PropTypes.string,
}

export default ReaProcessoExtraJudicial
